import Vue from 'vue'
import Vuex from 'vuex'

import * as firebase from 'firebase/app'
import 'firebase/analytics'

// import VuexEasyFirestore from 'vuex-easy-firestore'
import { Firebase, initFirebase } from '../config/firebase.js'

import auth from './modules/auth'
import user from './modules/user'
import ticket from './modules/ticket'

import gallery from './modules/gallery'
import project from './modules/project'
import watching from './modules/watching'
import comments from './modules/comments'
import invite from './modules/invite'
import tree from './modules/tree'
import document from './modules/document'
import search from './modules/search'
import notes from './modules/notes'

import input from './modules/input'

import confirm from './modules/confirm'
import payment from './modules/payment'

import modal from './modules/modal'

import error from './modules/error'

import welcome from './modules/welcome'

// const easyFirestore = VuexEasyFirestore(
//     [], { logging: true, FirebaseDependency: Firebase }
// )

Vue.use(Vuex)

export default new Vuex.Store({
    // plugins: [easyFirestore],
    modules: {
        auth,
        user,
        ticket,

        gallery,
        project,
        watching,
        comments,
        invite,
        tree,
        document,
        search,
        notes,

        input,

        confirm,
        payment,

        modal,

        error,

        welcome
    }
})

initFirebase().catch(error => {
    // take user to a page stating an error occurred
    // (might be a connection error, or the app is open in another tab)
    console.error(error);
});

firebase.analytics()
Vue.prototype.$analytics = firebase.analytics()


// WEBPACK FOOTER //
// ./src/vuex/store.js